import { render, staticRenderFns } from "./FieldBox.vue?vue&type=template&id=4f0ad1b8"
import script from "./FieldBox.vue?vue&type=script&lang=js"
export * from "./FieldBox.vue?vue&type=script&lang=js"
import style0 from "./FieldBox.vue?vue&type=style&index=0&id=4f0ad1b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports